import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { type components } from '@akillidernek/api-client'
import { Button, Icon } from '@akillidernek/ui'
import { api } from '../api'

type Duyuru = components['schemas']['AnnouncementRead']

const KAPATILANLAR_ANAHTARI = 'ad.kapatilan-duyurular'

/**
 * Platform duyuru bandı — YES-169.
 *
 * Personelin bütün derneklere söylediği şey ("Cumartesi bakım var"). Kullanıcı
 * bandı kapatabilir; kapatma bu tarayıcıda kalır ve duyuru DÜZENLENİRSE band
 * yeniden çıkar — anahtar `id:updated_at`. Bakım saati değişmişse eski "okudum"
 * geçersiz olmalı.
 */
export function DuyuruBandi() {
  const [kapatilanlar, setKapatilanlar] = useState<Set<string>>(kapatilanlariOku)
  const { data } = useQuery({
    queryKey: ['announcements-active'],
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/announcements/active')
      return data ?? []
    },
    // Duyuru dakikada bir değişmez; her sayfa geçişinde sormaya gerek yok.
    staleTime: 5 * 60 * 1000,
  })

  const gorunenler = (data ?? []).filter((d) => !kapatilanlar.has(anahtar(d)))
  if (gorunenler.length === 0) return null

  function kapat(duyuru: Duyuru) {
    const sonraki = new Set(kapatilanlar)
    sonraki.add(anahtar(duyuru))
    setKapatilanlar(sonraki)
    kapatilanlariYaz(sonraki)
  }

  return (
    <>
      {gorunenler.map((duyuru) => {
        const uyari = duyuru.tone === 'warning'
        return (
          <div
            key={duyuru.id}
            role={uyari ? 'alert' : 'status'}
            className={
              uyari
                ? 'flex items-start gap-2 bg-[var(--ad-warning)]/20 px-5 py-2 text-xs text-[var(--ad-text)]'
                : 'flex items-start gap-2 bg-[var(--ad-primary)]/15 px-5 py-2 text-xs text-[var(--ad-text)]'
            }
          >
            <Icon
              name={uyari ? 'shield-alert' : 'megaphone'}
              size={16}
              primaryColor={uyari ? 'var(--ad-warning)' : 'var(--ad-primary)'}
              aria-hidden
            />
            <span className="min-w-0 flex-1">
              <strong>{duyuru.title}.</strong> {duyuru.body}
            </span>
            <Button size="sm" variant="ghost" onClick={() => kapat(duyuru)} aria-label="Kapat">
              Kapat
            </Button>
          </div>
        )
      })}
    </>
  )
}

function anahtar(duyuru: Duyuru) {
  return `${duyuru.id}:${duyuru.updated_at}`
}

function kapatilanlariOku(): Set<string> {
  try {
    const ham = window.localStorage.getItem(KAPATILANLAR_ANAHTARI)
    const liste: unknown = ham ? JSON.parse(ham) : []
    return new Set(Array.isArray(liste) ? liste.filter((x) => typeof x === 'string') : [])
  } catch {
    return new Set()
  }
}

function kapatilanlariYaz(kume: Set<string>) {
  try {
    // Son 50 kayıt yeter; eski duyuruların anahtarı bir daha gelmez.
    window.localStorage.setItem(KAPATILANLAR_ANAHTARI, JSON.stringify([...kume].slice(-50)))
  } catch {
    // Özel pencere ya da dolu depo: band bir sonraki açılışta yine çıkar, o kadar.
  }
}
